import { GLOBAL } from 'saddlebag-browser';

const USER_AGENT_PATTERN = /Skyscanner/;

export default function isWebInApp(): boolean {
  const nav = GLOBAL.getNavigator() as Navigator & {
    userAgent?: string;
  };
  if (!nav.userAgent) {
    return false;
  }
  return USER_AGENT_PATTERN.test(nav.userAgent);
}
